function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#90959A",
  fillRule: "evenodd",
  d: "M4.25 3.333h8.5c.783 0 1.417.635 1.417 1.417v8.5c0 .782-.634 1.417-1.416 1.417h-8.5c-.783 0-1.417-.635-1.417-1.417v-8.5c0-.782.634-1.417 1.417-1.417zm1.417 2.834h5.667c.391 0 .708.317.708.708 0 .391-.317.708-.708.708H5.667c-.39 0-.708-.317-.708-.708 0-.391.317-.708.708-.708zm5.667 2.125H5.667c-.39 0-.708.317-.708.708 0 .391.317.708.708.708h5.667c.391 0 .708-.317.708-.708 0-.391-.317-.708-.708-.708zm-5.667 2.125h2.125c.392 0 .709.317.709.708 0 .391-.317.708-.709.708H5.667c-.39 0-.708-.317-.708-.708 0-.391.317-.708.708-.708z",
  clipRule: "evenodd"
});

var SvgDocument = function SvgDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    fill: "none",
    viewBox: "0 0 17 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document.c4ba5b31.svg";
export { ForwardRef as ReactComponent };